module.exports = __webpack_public_path__ + "public/img/300x200.f960c3f1.png";